
const MapKey = 'AIzaSyAtOZ48_gxKiPIhotlLFyszeXD7P_DAKJE';

export default MapKey;
